import { EventNames, globalEventBus } from '@littlebird/event-bus';
import { useEffect } from 'react';

import { subscriptionApis } from '@/features/subscription/subscription.query';
import { teamApis } from '@/features/team/team.query';
import { queryClient } from '@/query/client';

const refreshBilling = () => {
  void subscriptionApis.getStatus();
  void teamApis.fetchDashboard({ silent: true });
  for (const key of ['credit-balance', 'credit-packs', 'team-wallet']) {
    void queryClient.invalidateQueries({ queryKey: [key] });
  }
};

export const useBillingUpdatedEvents = () => {
  useEffect(() => {
    const subscriptions = [
      globalEventBus.on(EventNames.BILLING_UPDATED, refreshBilling),
      globalEventBus.on(EventNames.WS_RECONNECTED, refreshBilling),
    ];

    return () =>
      subscriptions.forEach((subscription) => subscription.unsubscribe());
  }, []);
};
